import { styled } from "@mui/system"
import { Box, Button, Typography } from "@mui/material"

export const SectionTitle = styled(Typography)`
    font-size: 1rem;
    font-weight: 600;
    color: #333;
    display: flex;
    align-items: center;
    gap: 8px;
`;
export const SecondarySectionTitle = styled(Typography)`
    font-size: 12px;
    font-weight: 600;
    color: #333;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const BrowseButton = styled(Button)`
  background: #f3f8fc;
  color: #3a3c3f;
  text-transform: none;
  box-shadow: none;
  border-radius: 20px;
  margin-left: 16px;
  &:hover {
    background: #e6f0fa;
  }
`;

export const Row = styled(Box)`
  display: flex;
  align-items: center;
  margin-top: 32px;
`;
export const Wrapper = styled(Box)({
  backgroundColor: "var(--white)",
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
  padding: "32px",
  gap: 16,
})